// NOTE: Do not add any external dependency here! This util is used inside independent "bettingLoader".

function adaptBettingOptions(
    bettingOptions: APIBettingOptions
): BettingOptions {
    const {
        currency,
        isAuthorized,
        locale,
        rootElement,
        selectedSportIds,
        sportIds,
        token,
        tournamentIds,
        features,
        url: {
            static_endpoint,
            public_sv,
            bettingPath,
            pagePath,
            gqlEndpoint = public_sv,
            staticEndpoint = static_endpoint,
        },
        participantFeatures,
    } = bettingOptions;

    const adaptedSelectedSportIds =
        !selectedSportIds || !selectedSportIds.length
            ? sportIds
            : selectedSportIds;

    return {
        url: {
            gqlEndpoint,
            staticEndpoint,
            pagePath,
            bettingPath,
            static_endpoint: staticEndpoint,
            public_sv: gqlEndpoint,
        },
        features,
        participantFeatures: participantFeatures || {},
        currency,
        locale,
        sportIds,
        tournamentIds,
        token,
        rootElement,
        isAuthorized,
        selectedSportIds: adaptedSelectedSportIds,
    };
}

export default adaptBettingOptions;
